<template>
	<el-card header="保障车辆">
		<avue-crud
			ref="crud"
			:data="dataCar"
			:option="optionCar"
			:table-loading="tableLoading"
			@cell-mouse-leave="onCellMouseLeave"></avue-crud>

		<div style="display: flex; justify-content: center; margin-top: 20px">
			<el-button v-if="!isSubmitCar" icon="el-icon-check" type="primary" @click="onCarSubmit()">确认</el-button>
			<el-button v-else icon="el-icon-edit" type="default" @click="onCarEdit()">修改</el-button>
		</div>
	</el-card>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {optionCar} from '@/const/crud/insurance/policy'
import {rule} from '@/util/validateRules'

export default {
	name: 'carForm',
	mixins: [],
	components: {},
	props: {
		formSubmit: Object,
		tableLoading: Boolean,
	},
	data() {
		return {
			optionCar: this.deepClone(optionCar),
			dataCar: [
				{
					licenseNo: '',
					vin: '',
					insureSeatNum: '',
					seatNum: '',
					engineNo: '',
					$cellEdit: true,
				},
			],
			isSubmitCar: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		onCellMouseLeave() {},
		onCarSubmit() {
			let {
				isHolderSubmitted = false,
				isPlanSubmitted = false,
				isPeriodSubmitted = false,
				isInsuredSubmitted = false,
				sameUnit = false,
			} = this.formSubmit
			let tempMsg = ''
			if (!isHolderSubmitted) {
				tempMsg = '请确认投保企业!'
			} else if (!isInsuredSubmitted && !sameUnit) {
				tempMsg = '请确认被保企业!'
			} else if (!isPlanSubmitted) {
				tempMsg = '请确认投保方案'
			} else if (!isPeriodSubmitted) {
				tempMsg = '请确认生效时间'
			}
			if (!this.validatenull(tempMsg)) {
				this.$message.error(tempMsg)
				return
			}
			//确认
			let {licenseNo = '', vin = '', insureSeatNum = '', seatNum = '', engineNo = ''} = this.dataCar[0]
			if (!licenseNo || !vin || !insureSeatNum || !seatNum || !engineNo) {
				this.$message.error('请完善保障车辆信息!')
				return
			}
			if (!rule.validatorCarMethod(licenseNo)) {
				this.$message.error('车牌号输入有误!')
				return
			}
			if (vin.length !== 17) {
				this.$message.error('车架号输入有误!')
				return
			}
			let message = ''
			if (this.validatenull(parseInt(insureSeatNum)) || this.validatenull(parseInt(seatNum))) {
				message = '投保座位数和核定座位数只能为数字'
			} else {
				if (parseInt(insureSeatNum) > parseInt(seatNum) && parseInt(insureSeatNum) !== 3) {
					message = '投保座位数不能大于核定座位数'
				}
			}
			if (!this.validatenull(message)) {
				this.$alert(message, '提示')
				return
			}
			//确定啦
			this.isSubmitCar = true
			this.dataCar[0].$cellEdit = false
			//算钱
			this.$emit('onSubmitCarData', [
				{
					licenseNo,
					vin,
					insureSeatNum,
					seatNum,
					engineNo,
				},
			])
		},
		onCarEdit() {
			this.dataCar[0].$cellEdit = true
			this.isSubmitCar = false
			this.$emit('onSubmitCarData', null)
		},
		onLicenseNoChange({value}, column) {
			if (!this.validatenull(value)) {
				this.dataCar[0].licenseNo = value.toUpperCase()
			}
		},
		setPremiumData({priceId, premium}) {
			let tempData = this.deepClone(this.dataCar[0])
			tempData.premium = premium
			tempData.price = premium * 100
			tempData.priceId = priceId
			this.dataCar = [tempData]
		},
		getCheckInsureData() {
			return this.dataCar
		},
		setDataCarForm(listData) {
			this.dataCar = listData
			this.dataCar[0].$cellEdit = true
			let {price = 0} = this.dataCar[0]
			if (price > 0) {
				this.dataCar[0].premium = price / 100
			}
		},
	},
	created() {},
	mounted() {
		let licenseNo = this.findObject(this.optionCar.column, 'licenseNo')
		licenseNo.change = this.onLicenseNoChange
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped></style>
